var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpSymbolikuvitus96079(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-96-079-1{fill:#fff;}.cls-96-079-2,.cls-96-079-3{fill:none;}.cls-96-079-2{stroke:#6e6e6e;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.25px;}.cls-96-079-3{opacity:0.2;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "taustavalko"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-96-079-1",
    width: 96,
    height: 96
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-96-079-2",
    d: "M55.87,74.1l1.54-.25a8.94,8.94,0,0,0,6.94-5.12c2.59-6,1.93-16,2.55-25.22.54-8.11.77-10.19,1.07-13.58.25-3.12,1-7.49-1.65-8C62.56,21.3,62,35.24,59.57,41.83c.38-5.51,1.34-22.35,1.34-22.35.06-3.8-.52-6.69-3.19-6.92C54.54,12.29,54.06,18,54.06,18L51.8,39.24l-.72-25.33c0-2.53-1.57-5.07-3.56-4.9S44,10.92,44,13.45L43.24,39.5,41.19,18.57c-.54-3.53-.85-6.52-3.8-6s-2.53,4.87-2.53,7.4l.46,20.3-.8,10.6S32.46,43,31.61,40.39c-1.15-3.54-4.64-5.6-7-5s-1.3,2.43-.53,4.48c1.31,3.37,3.18,4.4,4,15.41.31,7.77,4.88,14.9,9,17C40.68,74.11,43,73.84,43,73.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96-079-2",
    d: "M34.52,50.85a20.1,20.1,0,0,1,10,6.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96-079-2",
    d: "M37.77,87c.83-7.43.76-13.88.83-14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96-079-2",
    d: "M59.56,73.41s.29,8.75.79,13.59"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpSymbolikuvitus96079);
export default __webpack_public_path__ + "static/media/OP_symbolikuvitus_96_079.c081bc53855389dcfdeee32eb33bcec1.svg";
export { ForwardRef as ReactComponent };